import React from "react";
import { CTALink } from "@/components/common/CTALink";
import { Reveal } from "@/components/common/Reveal";

export const CtaBand = ({
  title = "Ready to communicate smarter?",
  subtitle = "Tell us your requirement and our team will help you choose the right mix of WhatsApp, SMS and telephony.",
  primary = { to: "/pricing", label: "Get Started" },
  secondary = { to: "/contact", label: "Talk to an Expert" },
}) => {
  return (
    <section className="et-section" data-testid="home-cta-band">
      <div className="et-container">
        <Reveal>
          <div className="et-navy-band relative overflow-hidden rounded-3xl px-6 py-12 sm:px-12 sm:py-16 text-center">
            <div className="absolute inset-0 et-dot-grid opacity-[0.15]" />
            <div className="relative">
              <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-semibold text-white tracking-tight max-w-2xl mx-auto">
                {title}
              </h2>
              <p className="mt-4 text-slate-300 max-w-2xl mx-auto text-base leading-relaxed">{subtitle}</p>
              <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
                <CTALink to={primary.to} variant="accent" withArrow>{primary.label}</CTALink>
                <CTALink to={secondary.to} variant="outlineLight">{secondary.label}</CTALink>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
